var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c("add-subdomain-form", {
            on: {
              "subdomain-added": _vm.reloadTable
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c("subdomains-table", {
            attrs: {
              "table-should-be-reloaded": _vm.tableShouldBeReloaded
            },
            on: {
              "table-reloaded": _vm.tableReloaded
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }